import ApplicationLoadError, { ApplicationLoadErrorProps } from './index';
import Button from '@mui/material/Button';

const LocalStorageError = (
  props: Pick<ApplicationLoadErrorProps, 'logoPath' | 'isAdminSite'>,
) => {
  return (
    <ApplicationLoadError
      {...props}
      title="Browser storage required"
      description="The Further platform requires access to browser storage
            (localStorage) to function properly. Without it, the application
            cannot maintain your login session or save your preferences."
      instructionsTitle="To fix this issue:"
      instructions={[
        'Check your browser settings and ensure third-party data storage is enabled.',
        "If you're using Chrome, check Settings → Privacy and security → Site settings → Cookies and other site data.",
        'Try refreshing this page after enabling storage.',
      ]}
      action={
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh page
        </Button>
      }
    />
  );
};

export default LocalStorageError;
